import type { MarketplaceIconProps } from "../../types"

/**
 * This OpenSea Logo is used specifically for branding purposes e.g. navbar logo, onboarding logo, etc.
 */
export const OpenSeaBrandLogo = ({
  size = 24,
  withBackground = true,
  ...rest
}: MarketplaceIconProps & {
  withBackground?: boolean
}) => {
  if (withBackground) {
    return (
      <svg
        aria-label="OpenSea"
        fill="none"
        height={size}
        viewBox="0 0 30 30"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g>
          <path
            d="M15.131 0C6.743-.067-.069 6.744.001 15.132.07 23.276 6.725 29.931 14.869 30c8.388.072 15.202-6.742 15.13-15.13C29.932 6.727 23.276.07 15.131 0Z"
            fill="#0086FF"
          />
          <path
            d="M14.978 4.634c.537 0 .972.435.972.972v1.248c2.982 1.392 4.935 3.702 4.935 6.315 0 1.533-.67 2.96-1.827 4.16-.222.23-.53.36-.852.36h-2.254v1.857h2.83c.61 0 1.706-1.158 2.225-1.856 0 0 .022-.034.082-.052.06-.018 5.198-1.197 5.198-1.197a.17.17 0 0 1 .214.162v1.081c0 .07-.037.13-.102.158-.352.15-1.515.69-2 1.362-1.247 1.737-2.2 4.467-4.33 4.467h-8.887c-3.147 0-5.78-2.498-5.778-5.825 0-.082.07-.15.153-.15h4.212c.145 0 .26.117.26.26v.813c0 .432.349.783.782.783h3.195v-1.86h-2.182a9.293 9.293 0 0 0 2.002-5.783c0-2.437-.934-4.66-2.464-6.322.925.108 1.81.292 2.644.537v-.518c0-.537.435-.972.972-.972Zm-4.333 2.83a7.154 7.154 0 0 1 1.536 4.44c0 1.45-.43 2.8-1.17 3.926h-5.2l4.834-8.365Z"
            fill="#FFF"
          />
        </g>
      </svg>
    )
  }

  return (
    <svg
      aria-label="OpenSea"
      fill="none"
      height={size}
      viewBox="0 0 30 30"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.978 4.634c.537 0 .972.435.972.972v1.248c2.982 1.392 4.935 3.702 4.935 6.315 0 1.533-.67 2.96-1.827 4.16-.222.23-.53.36-.852.36h-2.254v1.857h2.83c.61 0 1.706-1.158 2.225-1.856 0 0 .022-.034.082-.052.06-.018 5.198-1.197 5.198-1.197a.17.17 0 0 1 .214.162v1.081c0 .07-.037.13-.102.158-.352.15-1.515.69-2 1.362-1.247 1.737-2.2 4.467-4.33 4.467h-8.887c-3.147 0-5.78-2.498-5.778-5.825 0-.082.07-.15.153-.15h4.212c.145 0 .26.117.26.26v.813c0 .432.349.783.782.783h3.195v-1.86h-2.182a9.293 9.293 0 0 0 2.002-5.783c0-2.437-.934-4.66-2.464-6.322.925.108 1.81.292 2.644.537v-.518c0-.537.435-.972.972-.972Zm-4.333 2.83a7.154 7.154 0 0 1 1.536 4.44c0 1.45-.43 2.8-1.17 3.926h-5.2l4.834-8.365Z"
        fill="#0086FF"
        fillRule="nonzero"
      />
    </svg>
  )
}
